import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCheckCircle, faRotateRight, faAward, faTrophy, faBookOpen } from "@fortawesome/free-solid-svg-icons";
import { Modal } from "antd";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import { API_BASE_URL } from "../config/api";
import Navbar from "./Navbar";
import Footer from "./header and footer/Footer";

function Assessment() {
  const location = useLocation();
  const navigate = useNavigate();
  const courseId = location.pathname.split("/")[2];
  const [test, setTest] = useState([]);
  const [userId] = useState(localStorage.getItem("id"));
  const [userChoices, setUserChoices] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [totalQsns, setTotalQsns] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [finalScore, setFinalScore] = useState(0);
  const [finalCorrect, setFinalCorrect] = useState(0);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/questions/${courseId}`)
      .then((res) => res.json())
      .then((res) => {
        if (Array.isArray(res)) {
          setTest(res);
          setTotalQsns(res.length);
        }
      })
      .catch((error) => console.error("Error fetching assessment questions:", error));
  }, [courseId]);

  const handleOptionSelect = (questionIndex, selectedOption) => {
    setUserChoices((prev) => ({ ...prev, [questionIndex]: selectedOption }));
  };

  const correctCount = test.reduce((acc, qsn, idx) => {
    return userChoices[idx] === qsn.answer ? acc + 1 : acc;
  }, 0);

  const handleMarks = () => {
    const score = totalQsns > 0 ? Math.round((correctCount / totalQsns) * 100) : 0;
    setFinalScore(score);
    setFinalCorrect(correctCount);

    axios
      .post(`${API_BASE_URL}/api/assessments/add/${userId}/${courseId}`, {
        courseId,
        userId,
        marks: score
      })
      .then((response) => console.log("Marks saved:", response.data))
      .catch((error) => console.error("Error saving marks:", error));

    setSubmitted(true);
    setOpenModal(true);
  };

  const handleReset = () => {
    setUserChoices({});
    setSubmitted(false);
  };

  const isCourseCompleted = finalScore >= 90;

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: "#f8fafc" }}>
      <Navbar page="courses" />

      {/* Header Banner */}
      <div className="page-banner" style={{ padding: "48px 6% 40px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px", justifyContent: "center", marginBottom: "14px" }}>
          <button
            onClick={() => navigate(`/course/${courseId}`)}
            style={{
              background: "rgba(255,255,255,0.15)",
              color: "#fff",
              border: "none",
              padding: "6px 16px",
              borderRadius: "20px",
              cursor: "pointer",
              fontSize: "0.88rem",
              fontWeight: 600
            }}
          >
            <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: "6px" }} />
            Back to Course Module
          </button>
        </div>
        <h1>Assessment Quiz</h1>
        <p>Test your understanding of the course concepts and evaluate your score.</p>
      </div>

      {/* Assessment Container */}
      <div style={{ flex: 1, padding: "40px 6% 80px", maxWidth: "860px", margin: "0 auto", width: "100%" }}>
        {test.length === 0 ? (
          <div style={{ textAlign: "center", padding: "60px 0", color: "#64748b" }}>
            <FontAwesomeIcon icon={faBookOpen} spin style={{ fontSize: "2rem", color: "#4f46e5", marginBottom: "14px" }} />
            <p>Loading assessment questions...</p>
          </div>
        ) : (
          <div>
            {test.map((question, qIdx) => (
              <div
                key={question.no || qIdx}
                style={{
                  background: "#fff",
                  borderRadius: "16px",
                  padding: "28px",
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 4px 6px -1px rgba(0,0,0,0.03)",
                  marginBottom: "24px"
                }}
              >
                <div style={{ display: "flex", gap: "12px", alignItems: "flex-start", marginBottom: "18px" }}>
                  <span
                    style={{
                      background: "#e0e7ff",
                      color: "#4f46e5",
                      fontWeight: 800,
                      fontSize: "0.88rem",
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      marginTop: "2px"
                    }}
                  >
                    {qIdx + 1}
                  </span>
                  <div style={{ fontSize: "1.05rem", fontWeight: 700, color: "#0f172a", flex: 1, lineHeight: 1.5 }}>
                    <ReactMarkdown
                      components={{
                        pre: ({node, ...props}) => <pre style={{ background: "#0f172a", color: "#38bdf8", padding: "14px", borderRadius: "10px", overflowX: "auto", fontSize: "0.88rem", marginTop: "10px" }} {...props} />,
                        code: ({node, inline, ...props}) => inline ? <code style={{ background: "#e2e8f0", color: "#4f46e5", padding: "2px 6px", borderRadius: "4px", fontSize: "0.9rem" }} {...props} /> : <code {...props} />
                      }}
                    >
                      {question.question}
                    </ReactMarkdown>
                  </div>
                </div>

                {/* Options List */}
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                  {[question.option1, question.option2, question.option3, question.option4].map((opt, oIdx) => {
                    if (!opt) return null;
                    const isSelected = userChoices[qIdx] === opt;

                    return (
                      <div
                        key={oIdx}
                        onClick={() => handleOptionSelect(qIdx, opt)}
                        style={{
                          padding: "14px 20px",
                          borderRadius: "12px",
                          border: "1.5px solid",
                          borderColor: isSelected ? "#4f46e5" : "#e2e8f0",
                          background: isSelected ? "#f5f3ff" : "#fff",
                          color: isSelected ? "#4f46e5" : "#334155",
                          fontWeight: isSelected ? "700" : "500",
                          fontSize: "0.92rem",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          transition: "all 0.2s ease"
                        }}
                      >
                        <span>{opt}</span>
                        <input
                          type="radio"
                          name={`q_${qIdx}`}
                          checked={isSelected}
                          onChange={() => handleOptionSelect(qIdx, opt)}
                          style={{ accentColor: "#4f46e5", width: "18px", height: "18px", cursor: "pointer" }}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}

            {/* Action Bar */}
            <div style={{ display: "flex", gap: "16px", justifyContent: "flex-end", marginTop: "32px" }}>
              <button
                onClick={handleReset}
                style={{
                  background: "#f1f5f9",
                  color: "#475569",
                  border: "1px solid #cbd5e1",
                  padding: "12px 24px",
                  borderRadius: "10px",
                  fontWeight: 700,
                  fontSize: "0.92rem",
                  cursor: "pointer",
                  transition: "all 0.25s ease"
                }}
              >
                <FontAwesomeIcon icon={faRotateRight} style={{ marginRight: "8px" }} />
                Reset Answers
              </button>

              <button
                onClick={handleMarks}
                style={{
                  background: "linear-gradient(135deg, #4f46e5 0%, #3730a3 100%)",
                  color: "#fff",
                  border: "none",
                  padding: "12px 32px",
                  borderRadius: "10px",
                  fontWeight: 700,
                  fontSize: "0.95rem",
                  cursor: "pointer",
                  boxShadow: "0 4px 14px rgba(79,70,229,0.35)",
                  transition: "all 0.25s ease"
                }}
              >
                <FontAwesomeIcon icon={faCheckCircle} style={{ marginRight: "8px" }} />
                Submit Assessment
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Result Modal */}
      <Modal
        open={openModal}
        onOk={() => setOpenModal(false)}
        onCancel={() => setOpenModal(false)}
        footer={
          isCourseCompleted ? (
            <div style={{ display: "flex", gap: "10px", justifyContent: "center", paddingTop: "4px" }}>
              <button
                onClick={() => {
                  setOpenModal(false);
                  navigate("/learnings");
                }}
                style={{
                  background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                  color: "#fff",
                  border: "none",
                  padding: "11px 28px",
                  borderRadius: "10px",
                  fontWeight: 700,
                  cursor: "pointer",
                  fontSize: "0.92rem",
                  boxShadow: "0 4px 12px rgba(16,185,129,0.3)"
                }}
              >
                <FontAwesomeIcon icon={faAward} style={{ marginRight: "8px" }} />
                Go to My Learning
              </button>
              <button
                onClick={() => {
                  setOpenModal(false);
                  navigate(`/course/${courseId}`);
                }}
                style={{
                  background: "#f1f5f9",
                  color: "#475569",
                  border: "1px solid #cbd5e1",
                  padding: "11px 24px",
                  borderRadius: "10px",
                  fontWeight: 700,
                  cursor: "pointer",
                  fontSize: "0.92rem"
                }}
              >
                Back to Course
              </button>
            </div>
          ) : (
            <div style={{ display: "flex", gap: "10px", justifyContent: "center", paddingTop: "4px" }}>
              <button
                onClick={() => {
                  setOpenModal(false);
                  navigate(`/course/${courseId}`);
                }}
                style={{
                  background: "#4f46e5",
                  color: "#fff",
                  border: "none",
                  padding: "11px 28px",
                  borderRadius: "10px",
                  fontWeight: 700,
                  cursor: "pointer",
                  fontSize: "0.92rem"
                }}
              >
                Back to Course
              </button>
              <button
                onClick={() => {
                  setOpenModal(false);
                  setUserChoices({});
                  setSubmitted(false);
                }}
                style={{
                  background: "#f1f5f9",
                  color: "#475569",
                  border: "1px solid #cbd5e1",
                  padding: "11px 24px",
                  borderRadius: "10px",
                  fontWeight: 700,
                  cursor: "pointer",
                  fontSize: "0.92rem"
                }}
              >
                <FontAwesomeIcon icon={faRotateRight} style={{ marginRight: "6px" }} />
                Retake Quiz
              </button>
            </div>
          )
        }
      >
        <div style={{ textAlign: "center", padding: "20px 0" }}>
          {isCourseCompleted ? (
            <>
              <div
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 16px",
                  boxShadow: "0 8px 24px rgba(16,185,129,0.35)"
                }}
              >
                <FontAwesomeIcon icon={faTrophy} style={{ fontSize: "2.2rem", color: "#fff" }} />
              </div>
              <h2 style={{ color: "#0f172a", marginBottom: "8px", fontSize: "1.5rem" }}>🎉 Course Completed!</h2>
              <p style={{ fontSize: "1.3rem", color: "#10b981", fontWeight: 800, marginBottom: "10px" }}>
                You scored {finalScore}% ({finalCorrect} / {totalQsns} Correct)
              </p>
              <div
                style={{
                  background: "#f0fdf4",
                  border: "1px solid #bbf7d0",
                  borderRadius: "12px",
                  padding: "14px 20px",
                  marginBottom: "6px"
                }}
              >
                <p style={{ color: "#15803d", fontSize: "0.95rem", margin: 0, fontWeight: 600 }}>
                  🏆 Outstanding achievement! You've earned a course completion badge.
                </p>
              </div>
              <p style={{ color: "#64748b", fontSize: "0.85rem", marginTop: "8px" }}>
                This course is now marked as <strong>Completed</strong> in your learning dashboard.
              </p>
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faAward} style={{ fontSize: "3.5rem", color: "#4f46e5", marginBottom: "16px" }} />
              <h2 style={{ color: "#0f172a", marginBottom: "8px" }}>Assessment Submitted!</h2>
              <p style={{ fontSize: "1.25rem", color: "#4f46e5", fontWeight: 800, marginBottom: "12px" }}>
                You scored {finalScore}% ({finalCorrect} / {totalQsns} Correct)
              </p>
              <div
                style={{
                  background: finalScore >= 50 ? "#fffbeb" : "#fff1f2",
                  border: `1px solid ${finalScore >= 50 ? "#fde68a" : "#fecdd3"}`,
                  borderRadius: "12px",
                  padding: "14px 20px"
                }}
              >
                <p style={{ color: finalScore >= 50 ? "#92400e" : "#9f1239", fontSize: "0.92rem", margin: 0 }}>
                  {finalScore >= 50
                    ? "Good effort! You need 90% to earn a course completion badge. Review the material and try again!"
                    : "Keep going! Review the module carefully and retake the quiz to improve your score."}
                </p>
              </div>
            </>
          )}
        </div>
      </Modal>

      <Footer />
    </div>
  );
}

export default Assessment;
